import { render } from "./PurchaseReceive.vue?vue&type=template&id=22c2c43e&scoped=true"
import script from "./PurchaseReceive.vue?vue&type=script&lang=js"
export * from "./PurchaseReceive.vue?vue&type=script&lang=js"

import "./PurchaseReceive.vue?vue&type=style&index=0&id=22c2c43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c2c43e"]])

export default __exports__